/**
 * Form Validator Module
 * Handles validation for all form fields
 */
export class FormValidator {
  validateBreddInput(breddInput, breddValues) {
    const bredd = parseInt(breddInput.value) || 0
    let errorMessage = document.getElementById('bredd-error-message')
    let isValid = true

    breddInput.classList.remove('border-red-500')
    if (errorMessage) {
      errorMessage.remove()
    }

    function createErrorMessage() {
      errorMessage = document.createElement('div')
      errorMessage.id = 'bredd-error-message'
      breddInput.parentNode.appendChild(errorMessage)
      return errorMessage
    }

    if (!breddInput.value) {
      isValid = false
      breddInput.classList.add('border-red-500')
      errorMessage = errorMessage || createErrorMessage()
      errorMessage.textContent = `Bredden måste vara mellan ${breddValues.min}mm och ${breddValues.max}mm.`
    } else if (bredd < breddValues.min || bredd > breddValues.max) {
      isValid = false
      breddInput.classList.add('border-red-500')
      errorMessage = errorMessage || createErrorMessage()
      errorMessage.textContent = `Bredden måste vara mellan ${breddValues.min}mm och ${breddValues.max}mm.`
    }

    // Store validation state
    breddInput.setAttribute('data-valid', isValid)
    return isValid
  }

  validateTotalHeight(totalHeight) {
    const totalHeightField = document.getElementById('total_height_field')
    let errorMessage = document.getElementById('total-height-error-message')
    let isValid = true

    // Get min/max values from the input attributes
    const minTotalHeight = totalHeightField ? parseFloat(totalHeightField.getAttribute('min')) : 800
    const maxTotalHeight = totalHeightField
      ? parseFloat(totalHeightField.getAttribute('max'))
      : 3000

    if (totalHeightField) {
      totalHeightField.classList.remove('border-red-500')

      // Handle readonly fields differently
      if (totalHeightField.hasAttribute('readonly') || totalHeightField.hasAttribute('disabled')) {
        const parentDiv = totalHeightField.parentNode
        if (parentDiv) {
          parentDiv.classList.remove('border-red-500', 'bg-red-50')
        }
      }
    }

    // Create error message element if needed
    if (!errorMessage && totalHeightField) {
      errorMessage = document.createElement('div')
      errorMessage.id = 'total-height-error-message'
      totalHeightField.parentNode.appendChild(errorMessage)
    }

    // Validate range
    if (totalHeight < minTotalHeight || totalHeight > maxTotalHeight) {
      isValid = false

      if (totalHeightField) {
        if (
          totalHeightField.hasAttribute('readonly') ||
          totalHeightField.hasAttribute('disabled')
        ) {
          const parentDiv = totalHeightField.parentNode
          if (parentDiv) {
            parentDiv.classList.add('border-red-500', 'bg-red-50')
          }
        } else {
          totalHeightField.classList.add('border-red-500')
        }
      }

      if (errorMessage) {
        errorMessage.textContent = `Totalhöjden måste vara mellan ${minTotalHeight}mm och ${maxTotalHeight}mm.`
        errorMessage.style.display = 'block'
      }
    } else if (errorMessage) {
      errorMessage.style.display = 'none'
    }

    // Store validation state
    if (totalHeightField) {
      totalHeightField.setAttribute('data-valid', isValid)
    }

    return isValid
  }

  validateFormFields(requiredFields) {
    let allFieldsFilled = true

    requiredFields.forEach((field) => {
      if (!field.value) {
        allFieldsFilled = false
        field.classList.add('border-red-500')
      } else {
        field.classList.remove('border-red-500')
      }
    })

    return allFieldsFilled
  }
}
